import { action } from '@/lib/api';
import { getAppActionOutput } from '@/redux/actions/gravityActions';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import memoizeSelector from '@/redux/lib/memoizeSelector';
import selectors from '@/redux/selectors/selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const AppEditorOutputStateHandler = () => {
  const appId = useArgSelector(selectors.param, 'appId');
  const appVersion = useArgSelector(selectors.param, 'version');
  const actionId = useArgSelector(selectors.param, 'arg1');
  const update = useSelector(memoizeSelector('appActionResponseUpdate', (state) => state?.ui?.appActionResponseUpdate));

  useEffect(() => {
    if (!!update?.appId && !!update?.actionId) {
      if (update?.appId === appId && update?.actionId === actionId) {
        getAppActionOutput({ appId, appVersion, actionId, allMappers: true });
      }
      action('CLEAR_APP_ACTION_RESPONSE_UPDATE');
    }
  }, [update]);

  return null;
};

export default AppEditorOutputStateHandler;
